// import store from '_root/store'
import sessionService from '@/app/services/common/sessionService';
// test if user is logged
export default (to, from, next) => {
  const id = Number(sessionService.getCookie('_id'));
  const user = sessionService.getLocalData('_user');

  if (id && user && id === user.id) {
    next();
  } else {
    next(`/public/login?redirect=${to.fullPath}`);
  }
};
